import { Box, Container, Header, Toggle } from '@amzn/awsui-components-core';
import { FormikProps } from 'formik';
import React from 'react';
import { ApplicationFormValues } from '../../AdminModels';
import ApplicationOverviewConfig from './ApplicationOverviewConfig';
import ApplicationLogoConfig from './ApplicationLogoConfig';
import QChatConfig from './QChatConfig';
import McpConfigSection from './McpConfig';
import ApplicationLinksConfig from './ApplicationLinksConfig';

interface ApplicationDetailsProps {
  formik: FormikProps<ApplicationFormValues>;
}

const ApplicationDetails: React.FC<ApplicationDetailsProps> = ({ formik }) => {
  return (
    <>
      <div id="application-overview">
        <Box margin={{ bottom: 'l' }}>
          <Container header={<Header variant="h2">Application Overview</Header>}>
            <ApplicationOverviewConfig formik={formik} />
          </Container>
        </Box>
      </div>

      <div id="application-logo">
        <Box margin={{ bottom: 'l' }}>
          <Container
            header={
              <Header variant="h2" description="Choose a default logo or upload your own.">
                Application Logo
              </Header>
            }
          >
            <ApplicationLogoConfig formik={formik} />
          </Container>
        </Box>
      </div>

      <div id="q-chat-configuration">
        <Box margin={{ bottom: 'l' }}>
          <Container
            header={
              <Header
                variant="h2"
                description="Configure the QuickSight Q chat agent for this application."
                actions={
                  <Toggle
                    checked={formik.values.applicationDetails?.qChatConfig?.isEnabled || false}
                    onChange={({ detail }) => {
                      formik.setFieldValue('applicationDetails.qChatConfig.isEnabled', detail.checked);
                      if (!detail.checked) {
                        formik.setFieldValue('applicationDetails.qChatConfig.agentUrl', null);
                      }
                    }}
                  >
                    Enable
                  </Toggle>
                }
              >
                Q Chat Configuration
              </Header>
            }
          >
            <QChatConfig formik={formik} />
          </Container>
        </Box>
      </div>

      <div id="mcp-configuration">
        <Box margin={{ bottom: 'l' }}>
          <Container
            header={
              <Header
                variant="h2"
                description="Register this application as an MCP server with install commands, tools, and resources."
                actions={
                  <Toggle
                    checked={formik.values.applicationDetails?.mcpConfig?.isEnabled || false}
                    onChange={({ detail }) => {
                      if (detail.checked) {
                        formik.setFieldValue('applicationDetails.mcpConfig', {
                          isEnabled: true,
                          description: '',
                          category: '',
                          isFeatured: false,
                          terminalCommands: [],
                          resources: [],
                          toolGroups: [],
                          features: [],
                          contacts: []
                        });
                      } else {
                        formik.setFieldValue('applicationDetails.mcpConfig', { isEnabled: false });
                      }
                    }}
                  >
                    Enable
                  </Toggle>
                }
              >
                MCP Server Configuration
              </Header>
            }
          >
            <McpConfigSection formik={formik} />
          </Container>
        </Box>
      </div>

      <div id="application-links">
        <Box margin={{ bottom: 'l' }}>
          <Container
            header={
              <Header variant="h2" description="Configure application URLs and environment links.">
                Application Links
              </Header>
            }
          >
            <ApplicationLinksConfig formik={formik} />
          </Container>
        </Box>
      </div>
    </>
  );
};

export default ApplicationDetails;
